import { api } from '../../../services/api/apiClient';
import type { ApiResponse, Paginated, Query } from '../../../types/api';
import type { AdvanceBalances, Payslip, PayslipInput, PayslipPreview } from '../types/payrollTypes';

export const payrollService = {
  list: (query?: Query) => api.get<Paginated<Payslip>>('/payroll', query),
  get: (id: string) => api.get<ApiResponse<Payslip>>(`/payroll/${id}`).then((r) => r.data),
  /** Pay worked out from attendance before saving. */
  preview: (query: Query) => api.get<ApiResponse<PayslipPreview>>('/payroll/preview', query).then((r) => r.data),
  create: (body: PayslipInput) => api.post<ApiResponse<Payslip>>('/payroll', body).then((r) => r.data),
  cancel: (id: string, reason: string) => api.post<ApiResponse<Payslip>>(`/payroll/${id}/cancel`, { reason }).then((r) => r.data),
  /** Opens the printable salary slip PDF in a new tab. */
  openPdf: (id: string) => api.openPdf(`/payroll/${id}/pdf`),
  advances: () => api.get<ApiResponse<AdvanceBalances>>('/payroll/advances').then((r) => r.data),
};
